import React, { useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import InfoSection from '../InfoSection';
import { Button } from '../ButtonElements';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from '../HeroSection/HeroElements';
import { homeObjOne, homeObjTwo } from './SocialData';
import socialVideo from '../../videos/Social_media.mp4';

const SocialPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroContainer id="social-home">
        <HeroBg>
          <VideoBg playsInline autoPlay loop muted src={socialVideo} type="video/mp4" />
        </HeroBg>
        <HeroContent>
          <HeroH1>
            The future with social media
            <br />
            Learn how we can boost your business
          </HeroH1>
          <HeroP>
            Wiry can transform your business with strategic social media and future-proof
            campaigns with customized solutions that drive growth.
          </HeroP>
          <HeroBtnWrapper>
            <Button
              to="automation"
              smooth
              duration={500}
              spy
              offset={-80}
              primary
              dark
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              Learn More {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </HeroContent>
      </HeroContainer>
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjTwo} />
      <Footer />
    </>
  );
};

export default SocialPage;
